import { devWarn, devError, devInfo } from "@/lib/logger";
// Native-mobile-aware Google OAuth handler.
// Web: standard `window.location.href` redirect to Emergent auth.
// Capacitor native (iOS/Android): open OAuth in system browser (SFSafariViewController /
// Chrome Custom Tabs) — Google blocks OAuth inside a WebView, so this is required.
// The system browser then redirects to a web-hosted callback page that deep-links back
// into the native app via the custom URL scheme (moneyhub://auth-callback#session_id=...).

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AUTH_URL = "https://auth.emergentagent.com/";
const NATIVE_SCHEME = "moneyhub";
// Sentinel query flag added to the redirect URL when authing from a native shell,
// so the callback page knows to deep-link the result back into the app.
const NATIVE_HINT = "?mh_native=1";

export function isNativeShell() {
  try {
    // Prefer Capacitor's own detector if available
    if (typeof window !== "undefined" && window.Capacitor && typeof window.Capacitor.isNativePlatform === "function") {
      return window.Capacitor.isNativePlatform();
    }
    // Fallback UA sniff
    return /Capacitor|CapacitorWebView/i.test(navigator.userAgent || "");
  } catch (_) {
    return false;
  }
}

export async function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";

  if (!isNativeShell()) {
    // Web: standard redirect.
    window.location.href = `${AUTH_URL}?redirect=${encodeURIComponent(redirectUrl)}`;
    return;
  }

  // Native: open in system browser via Capacitor Browser plugin.
  const nativeRedirect = window.location.origin + "/dashboard" + NATIVE_HINT;
  const authUrl = `${AUTH_URL}?redirect=${encodeURIComponent(nativeRedirect)}`;

  try {
    const { Browser } = await import("@capacitor/browser");
    await Browser.open({ url: authUrl, presentationStyle: "popover" });
    // The rest happens via appUrlOpen listener registered in App.js.
    // When the callback page detects mh_native=1, it triggers moneyhub://auth-callback#session_id=...
    // which returns focus + payload to the app.
  } catch (err) {
    // Plugin missing / not native — fall back to full-page redirect.
    devWarn("Native browser open failed, falling back:", err?.message || err);
    window.location.href = authUrl;
  }
}

export { NATIVE_SCHEME, NATIVE_HINT };
